export enum StandardPlanPermissionEnum {
    None                = 0x00,
    CanSearch           = 0x01 << 0,
    CanView             = 0x01 << 1,
    CanEdit             = 0x01 << 2,
    CanCreate           = 0x01 << 3,
    CanViewUnpublished  = 0x01 << 4,
}
